// extracted by mini-css-extract-plugin
module.exports = {"container":"tnC_container__298e3","error":"tnC_error__2-fPL","checkbox":"tnC_checkbox__14tBO","underline":"tnC_underline__1vbGF","text":"tnC_text__1MykC","tick":"tnC_tick__3lX2-"};